import React, { ReactElement } from 'react'

export default function StatsArrow({ stroke = '#36AF67', isDecline = false }): ReactElement {
  return <svg style={isDecline ? { transform: 'rotate(90deg)' } : {}} width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1H6M6 1V6M6 1L1 6" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}
